// Copyright 2024 Sorama B.V.

import { GenericMeasurement, Point2D, Point3D } from "datatypes/SoramaWebApi";
import { IMeasurementProcessorResolver } from "services/Measurement/IMeasurementProcessorResolver";
import { IPsychoAcousticsProcessingService } from "services/SoundProcessing/IPsychoAcousticsProcessingService";
import { PsychoAcousticMetricType } from "../../PsychoAcoustics/SpiderChart/SpiderChart";
import { ITimeSignalProvider } from "./ITimeSignalProvider";

export class PsychoAcousticSignalProvider implements ITimeSignalProvider {
    constructor(
        private readonly processorResolver: IMeasurementProcessorResolver,
        private readonly metricType: PsychoAcousticMetricType
    ) {}

    public async getTimeSignal(
        measurement: GenericMeasurement,
        mic: Point3D,
        progressCallback: (progress: number) => void
    ): Promise<Point2D[]> {
        const processor = await this.processorResolver.resolveProcessor<IPsychoAcousticsProcessingService>(
            IPsychoAcousticsProcessingService,
            measurement
        );

        const result = await processor.getPsychoAcousticMetricOverTime(
            measurement,
            {
                requestedMicrophone: mic,
                metricName: this.metricType,
            },
            progressCallback
        );

        return result.data;
    }
}
